import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Copy } from "lucide-react";
import { api, errMsg } from "../../lib/api";
import { useStore } from "../../context/StoreContext";
import { Switch } from "../ui/switch";

const toLocal = (iso) => (iso ? new Date(iso).toISOString().slice(0, 16) : "");

export const LaunchPanel = () => {
  const store = useStore();
  const [prelaunch, setPrelaunch] = useState(store.prelaunch);
  const [date, setDate] = useState(toLocal(store.launch_date));
  const [signups, setSignups] = useState([]);

  useEffect(() => { setPrelaunch(store.prelaunch); setDate(toLocal(store.launch_date)); }, [store.prelaunch, store.launch_date]);
  useEffect(() => { api.get("/admin/launch-signups").then((r) => setSignups(r.data)); }, []);

  const save = async () => {
    try {
      await api.put("/admin/settings", { prelaunch, launch_date: date ? new Date(date).toISOString() : null });
      await store.reload();
      toast.success(prelaunch ? "Pre-Launch-Modus aktiv" : "Shop ist geöffnet!");
    } catch (e) { toast.error(errMsg(e)); }
  };
  const copy = () => { navigator.clipboard.writeText(signups.map((s) => s.email).join("\n")); toast.success("E-Mails kopiert"); };

  return (
    <div className="grid lg:grid-cols-2 gap-6">
      <div className="bg-white rounded-2xl border border-[#120E1F]/5 p-6 space-y-5" data-testid="launch-settings">
        <h3 className="font-display text-2xl">Launch-Einstellungen</h3>
        <label className="flex items-center justify-between gap-4">
          <span><span className="block text-sm font-semibold">Pre-Launch-Modus („Demnächst verfügbar“)</span>
            <span className="text-xs text-[#707783]">Alle Produkte zeigen die Jolgen-Kartenrückseite, Preise & Checkout sind ausgeblendet.</span></span>
          <Switch checked={prelaunch} onCheckedChange={setPrelaunch} data-testid="prelaunch-switch" />
        </label>
        <label className="block text-xs text-[#707783]">Launch-Datum (für Countdown, optional)
          <input type="datetime-local" value={date} onChange={(e) => setDate(e.target.value)} data-testid="launch-date-input"
            className="mt-1 w-full rounded-lg border border-[#120E1F]/10 px-3 py-2 text-sm" /></label>
        <button className="btn-gold" onClick={save} data-testid="launch-save-btn">Speichern</button>
      </div>
      <div className="bg-white rounded-2xl border border-[#120E1F]/5 p-6 space-y-4" data-testid="launch-signups">
        <div className="flex justify-between items-center">
          <h3 className="font-display text-2xl">Launch-Liste <span className="font-mono text-base text-[#6E3FB8]" data-testid="signup-count">({signups.length})</span></h3>
          {signups.length > 0 && <button className="btn-outline" onClick={copy} data-testid="copy-signups-btn"><Copy className="h-4 w-4" />Kopieren</button>}
        </div>
        <ul className="max-h-72 overflow-y-auto divide-y text-sm">
          {signups.map((s) => <li key={s.email} className="py-2 flex justify-between"><span>{s.email}</span><span className="text-xs text-[#707783]">{new Date(s.created_at).toLocaleDateString("de-DE")}</span></li>)}
          {signups.length === 0 && <li className="py-2 text-[#707783]">Noch keine Anmeldungen.</li>}
        </ul>
      </div>
    </div>
  );
};
